function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 38,
  height: 38,
  rx: 19,
  fill: "#2C7AFC"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-directions_svg__icon-directions_svg__a)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.37 22.5l-7.86-7.87a2.13 2.13 0 00-3.02 0l-7.86 7.86a2.13 2.13 0 000 3.02l7.86 7.86c.84.84 2.18.84 3.02 0l7.86-7.86c.84-.83.84-2.18 0-3.02zm-.88 2.13l-7.87 7.86a.88.88 0 01-1.25 0l-7.86-7.86a.88.88 0 010-1.25l7.87-7.87a.88.88 0 011.25 0l7.86 7.87s.26.2.26.62c0 .24-.1.46-.26.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.58 22.06c-.04-.07.1.09-2.2-2.25a.62.62 0 10-.88.88l1.1 1.12h-6.04a.62.62 0 00-.62.63v4.06a.62.62 0 001.25 0v-3.44h5.35l-1.11 1.13a.63.63 0 00.89.87l2.05-2.08c.35-.2.4-.65.21-.92z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-directions_svg__icon-directions_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(14 14)",
  d: "M0 0h20v20H0z"
})));

function SvgIconDirections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiPgogIDxyZWN0IHg9IjUiIHk9IjUiIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIgcng9IjE5IiBmaWxsPSIjMkM3QUZDIi8+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2EpIiBmaWxsPSIjZmZmIj4KICAgIDxwYXRoIGQ9Im0zMy4zNyAyMi41LTcuODYtNy44N2EyLjEzIDIuMTMgMCAwIDAtMy4wMiAwbC03Ljg2IDcuODZhMi4xMyAyLjEzIDAgMCAwIDAgMy4wMmw3Ljg2IDcuODZjLjg0Ljg0IDIuMTguODQgMy4wMiAwbDcuODYtNy44NmMuODQtLjgzLjg0LTIuMTggMC0zLjAyWm0tLjg4IDIuMTMtNy44NyA3Ljg2YS44OC44OCAwIDAgMS0xLjI1IDBsLTcuODYtNy44NmEuODguODggMCAwIDEgMC0xLjI1bDcuODctNy44N2EuODguODggMCAwIDEgMS4yNSAwbDcuODYgNy44N3MuMjYuMi4yNi42MmMwIC4yNC0uMS40Ni0uMjYuNjNaIi8+CiAgICA8cGF0aCBkPSJNMjguNTggMjIuMDZjLS4wNC0uMDcuMS4wOS0yLjItMi4yNWEuNjIuNjIgMCAxIDAtLjg4Ljg4bDEuMSAxLjEyaC02LjA0YS42Mi42MiAwIDAgMC0uNjIuNjN2NC4wNmEuNjIuNjIgMCAwIDAgMS4yNSAwdi0zLjQ0aDUuMzVsLTEuMTEgMS4xM2EuNjMuNjMgMCAwIDAgLjg5Ljg3bDIuMDUtMi4wOGMuMzUtLjIuNC0uNjUuMjEtLjkyWiIvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iYSI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0IDE0KSIgZD0iTTAgMGgyMHYyMEgweiIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgIconDirections as ReactComponent };